import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeavePlan from "..";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import { ReducersTypes } from "../../../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  isintervinigallowed: false,
  holiday: false,
  optholiday: false,
  weeklyoff: false,
  isinterviningholiday: false,
  holidayinterviningcount: 0,
  isholidayinterviningclubbed: false,
  isprefixholiday: false,
  holidayprefixcount: 0,
  issuffixholiday: false,
  holidaysuffixcount: 0,
  isinterviningoptholiday: false,
  optholidayinterviningcount: 0,
  isoptholidayinterviningclubbed: false,
  isprefixoptholiday: false,
  optholidayprefixcount: 0,
  issuffixoptholiday: false,
  optholidaysuffixcount: 0,
  isinterviningweeklyoff: false,
  weeklyoffinterviningcount: 0,
  isweeklyoffinterviningclubbed: false,
  isprefixweeklyoff: false,
  weeklyoffprefixcount: 0,
  issuffixweeklyoff: false,
  weeklyoffsuffixcount: 0,
};
class SandwichLeave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
    if (
      this.props.leavetypeid == 6
      || this.props.leavetypeid == 7
      || this.props.leavetypeid == 12
    ) {
      this.UpdateReducer();
    }
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const InitLeavesPolicy = props.InitLeavesPolicy.policy[ParentIndex];
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          isintervinigallowed: InitLeavesPolicy.isintervinigallowed,
          isinterviningholiday: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isinterviningholiday
            : this.state.isinterviningholiday,
          holidayinterviningcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.holidayinterviningcount
            : this.state.holidayinterviningcount,
          isholidayinterviningclubbed: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isholidayinterviningclubbed
            : this.state.isholidayinterviningclubbed,
          isprefixholiday: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isprefixholiday
            : this.state.isprefixholiday,
          holidayprefixcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.holidayprefixcount
            : this.state.holidayprefixcount,
          issuffixholiday: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.issuffixholiday
            : this.state.issuffixholiday,
          holidaysuffixcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.holidaysuffixcount
            : this.state.holidaysuffixcount,
          isinterviningoptholiday: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isinterviningoptholiday
            : this.state.isinterviningoptholiday,
          optholidayinterviningcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.optholidayinterviningcount
            : this.state.optholidayinterviningcount,
          isoptholidayinterviningclubbed: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isoptholidayinterviningclubbed
            : this.state.isoptholidayinterviningclubbed,
          isprefixoptholiday: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isprefixoptholiday
            : this.state.isprefixoptholiday,
          optholidayprefixcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.optholidayprefixcount
            : this.state.optholidayprefixcount,
          issuffixoptholiday: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.issuffixoptholiday
            : this.state.issuffixoptholiday,
          optholidaysuffixcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.optholidaysuffixcount
            : this.state.optholidaysuffixcount,
          isinterviningweeklyoff: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isinterviningweeklyoff
            : this.state.isinterviningweeklyoff,
          weeklyoffinterviningcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.weeklyoffinterviningcount
            : this.state.weeklyoffinterviningcount,
          isweeklyoffinterviningclubbed: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isweeklyoffinterviningclubbed
            : this.state.isweeklyoffinterviningclubbed,
          isprefixweeklyoff: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.isprefixweeklyoff
            : this.state.isprefixweeklyoff,
          weeklyoffprefixcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.weeklyoffprefixcount
            : this.state.weeklyoffprefixcount,
          issuffixweeklyoff: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.issuffixweeklyoff
            : this.state.issuffixweeklyoff,
          weeklyoffsuffixcount: InitLeavesPolicy.interviningpolicy
            ? InitLeavesPolicy.interviningpolicy.weeklyoffsuffixcount
            : this.state.weeklyoffsuffixcount,
        },
        () => {
          if (
            this.state.isinterviningholiday
            || this.state.isprefixholiday
            || this.state.issuffixholiday
          ) {
            this.setState({ holiday: true }, () => this.UpdateReducer());
          }
          if (
            this.state.isinterviningoptholiday
            || this.state.isprefixoptholiday
            || this.state.issuffixoptholiday
          ) {
            this.setState({ optholiday: true }, () => this.UpdateReducer());
          }
          if (
            this.state.isinterviningweeklyoff
            || this.state.isprefixweeklyoff
            || this.state.issuffixweeklyoff
          ) {
            this.setState({ weeklyoff: true }, () => this.UpdateReducer());
          }
        },
      );
    } else {
      this.setState({ ...ParentState });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (
      this.props.leavetypeid != 6
      && this.props.leavetypeid != 7
      && this.props.leavetypeid != 12
    ) {
      console.log("sss");
      if (!InitLeavesPolicy.policy[ParentIndex]) {
        const plan = LeavePlan.find(
          (x) => x.leavetypeid == this.state.leavetypeid,
        );
        InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
      }
      InitLeavesPolicy.policy[ParentIndex] = {
        ...InitLeavesPolicy.policy[ParentIndex],
        isintervinigallowed: this.state.isintervinigallowed,
      };
      InitLeavesPolicy.policy[ParentIndex].interviningpolicy = {
        isinterviningholiday: this.state.isinterviningholiday,
        holidayinterviningcount: this.state.holidayinterviningcount,
        isholidayinterviningclubbed: this.state.isholidayinterviningclubbed,
        isprefixholiday: this.state.isprefixholiday,
        holidayprefixcount: this.state.holidayprefixcount,
        issuffixholiday: this.state.issuffixholiday,
        holidaysuffixcount: this.state.holidaysuffixcount,
        isinterviningoptholiday: this.state.isinterviningoptholiday,
        optholidayinterviningcount: this.state.optholidayinterviningcount,
        isoptholidayinterviningclubbed: this.state
          .isoptholidayinterviningclubbed,
        isprefixoptholiday: this.state.isprefixoptholiday,
        optholidayprefixcount: this.state.optholidayprefixcount,
        issuffixoptholiday: this.state.issuffixoptholiday,
        optholidaysuffixcount: this.state.optholidaysuffixcount,
        isinterviningweeklyoff: this.state.isinterviningweeklyoff,
        weeklyoffinterviningcount: this.state.weeklyoffinterviningcount,
        isweeklyoffinterviningclubbed: this.state.isweeklyoffinterviningclubbed,
        isprefixweeklyoff: this.state.isprefixweeklyoff,
        weeklyoffprefixcount: this.state.weeklyoffprefixcount,
        issuffixweeklyoff: this.state.issuffixweeklyoff,
        weeklyoffsuffixcount: this.state.weeklyoffsuffixcount,
        holiday: this.state.holiday,
        optholiday: this.state.optholiday,
        weeklyoff: this.state.weeklyoff,
      };
    } else if (
      this.props.leavetypeid == 6
      || this.props.leavetypeid == 7
      || this.props.leavetypeid == 12
    ) {
      console.log("snad");
      if (!InitLeavesPolicy.policy[ParentIndex]) {
        const plan = LeavePlan.find(
          (x) => x.leavetypeid == this.state.leavetypeid,
        );
        InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
      }
      InitLeavesPolicy.policy[ParentIndex] = {
        ...InitLeavesPolicy.policy[ParentIndex],
        isintervinigallowed: true,
      };
      InitLeavesPolicy.policy[ParentIndex].interviningpolicy = {
        isinterviningholiday: true,
        holidayinterviningcount: 0,
        isholidayinterviningclubbed: false,
        isprefixholiday: false,
        holidayprefixcount: 0,
        issuffixholiday: false,
        holidaysuffixcount: 0,
        isinterviningoptholiday: true,
        optholidayinterviningcount: 0,
        isoptholidayinterviningclubbed: false,
        isprefixoptholiday: false,
        optholidayprefixcount: 0,
        issuffixoptholiday: false,
        optholidaysuffixcount: 0,
        isinterviningweeklyoff: true,
        weeklyoffinterviningcount: 0,
        isweeklyoffinterviningclubbed: false,
        isprefixweeklyoff: false,
        weeklyoffprefixcount: 0,
        issuffixweeklyoff: false,
        weeklyoffsuffixcount: 0,
        holiday: true,
        optholiday: true,
        weeklyoff: true,
      };
    }

    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange(name, arg, event) {
    if (arg == null) {
      this.setState({ [name]: 0 }, () => {
        this.setState({ [name]: arg }, () => this.UpdateReducer());
      });
    } else if (arg == 1) {
      this.setState({ [name]: arg }, () => this.UpdateReducer());
    } else {
      const numbers = /^[0-9]+$/;
      if (event.target.value.match(numbers)) {
        let value;
        if (
          Number(event.target.value) > Number(arg)
          || Number.isNaN(event.target.value)
        ) {
          value = this.state[name];
        } else value = Number(event.target.value);
        this.setState({ [name]: value }, () => this.UpdateReducer());
      }
    }
  }

  clear(holiday) {
    switch (holiday) {
      case "holiday": {
        this.setState(
          {
            isinterviningholiday: false,
            holidayinterviningcount: null,
            isholidayinterviningclubbed: false,
            isprefixholiday: false,
            holidayprefixcount: null,
            issuffixholiday: false,
            holidaysuffixcount: null,
          },
          () => this.UpdateReducer(),
        );
        break;
      }
      case "optholiday": {
        this.setState(
          {
            isinterviningoptholiday: false,
            optholidayinterviningcount: null,
            isoptholidayinterviningclubbed: false,
            isprefixoptholiday: false,
            optholidayprefixcount: null,
            issuffixoptholiday: false,
            optholidaysuffixcount: null,
          },
          () => this.UpdateReducer(),
        );
        break;
      }
      case "weeklyoff": {
        this.setState(
          {
            isinterviningweeklyoff: false,
            weeklyoffinterviningcount: null,
            isweeklyoffinterviningclubbed: false,
            isprefixweeklyoff: false,
            weeklyoffprefixcount: null,
            issuffixweeklyoff: false,
            weeklyoffsuffixcount: null,
          },
          () => this.UpdateReducer(),
        );
        break;
      }
      default:
        break;
    }
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "isintervinigallowed": {
        this.setState(
          {
            [name]: arg[0],
            holiday: false,
            optholiday: false,
            weeklyoff: false,
          },
          () => {
            this.clear("holiday");
            this.clear("optholiday");
            this.clear("weeklyoff");
          },
        );
        break;
      }
      case "holiday":
      case "optholiday":
      case "weeklyoff": {
        this.setState({ [name]: arg[0] }, () => {
          this.clear(name);
        });
        break;
      }
      case "isinterviningholiday": {
        this.setState(
          {
            [name]: arg[0],
            holidayinterviningcount: null,
            isholidayinterviningclubbed: false,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      }
      case "isinterviningoptholiday": {
        this.setState(
          {
            [name]: arg[0],
            optholidayinterviningcount: null,
            isoptholidayinterviningclubbed: false,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      }
      case "isinterviningweeklyoff": {
        this.setState(
          {
            [name]: arg[0],
            weeklyoffinterviningcount: null,
            isweeklyoffinterviningclubbed: false,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      }
      case "isholidayinterviningclubbed": {
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      }
      case "isoptholidayinterviningclubbed": {
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      }
      case "isweeklyoffinterviningclubbed": {
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      }
      case "isprefixholiday": {
        this.setState({ [name]: arg[0] }, () => {
          this.setState({ holidayprefixcount: null }, () => {
            this.UpdateReducer();
          });
        });
        break;
      }
      case "isprefixoptholiday": {
        this.setState({ [name]: arg[0] }, () => {
          this.setState({ optholidayprefixcount: null }, () => {
            this.UpdateReducer();
          });
        });
        break;
      }
      case "isprefixweeklyoff": {
        this.setState({ [name]: arg[0] }, () => {
          this.setState({ weeklyoffprefixcount: null }, () => {
            this.UpdateReducer();
          });
        });
        break;
      }
      case "issuffixholiday": {
        this.setState({ [name]: arg[0] }, () => {
          this.setState({ holidaysuffixcount: null }, () => {
            this.UpdateReducer();
          });
        });
        break;
      }
      case "issuffixoptholiday": {
        this.setState({ [name]: arg[0] }, () => {
          this.setState({ optholidaysuffixcount: null }, () => {
            this.UpdateReducer();
          });
        });
        break;
      }
      case "issuffixweeklyoff": {
        this.setState({ [name]: arg[0] }, () => {
          this.setState({ weeklyoffsuffixcount: null }, () => {
            this.UpdateReducer();
          });
        });
        break;
      }
      default:
        break;
    }
  }

  render() {
    const language = this.props.Language.sandwichleave;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          {this.props.leavetypeid != 6
            && this.props.leavetypeid != 7
            && this.props.leavetypeid != 12 && (
              <div>
                <p className="form-main-header margin-top-20">
                  <FormattedMessage
                    id="__LbSandwichedLeaves"
                    defaultMessage="Sandwiched/Intervening Leaves"
                  />
                </p>
                <p className="depedent-select-list-head">
                  If leaves are applied next to or in-between
                  holidays/weekly-offs, should there be additional leave
                  deductions?
                </p>
                <div className="inner-wrapper opaque">
                  <div className="">
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isintervinigallowed", true)
                      }
                      aria-expanded={this.state.isintervinigallowed == true}
                    >
                      <span>
                        Yes, deduct leaves for applied dates and additional
                        leaves in the following manner
                      </span>
                      {this.state.isintervinigallowed == true ? (
                        <span className="floatright ">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                    <div className="et-level2">
                      <Collapse
                        in={this.state.isintervinigallowed}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("holiday", !this.state.holiday)
                            }
                            aria-expanded={this.state.holiday}
                          >
                            <span>
                              <FormattedMessage
                                id="__LbHolidayFalls"
                                defaultMessage="Deduct if mandatory holidays occurs"
                              />
                            </span>
                            {this.state.holiday ? (
                              <span className="floatright selected-box">
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                  <path d="M0 0h24v24H0z" fill="none" />
                                  <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                </svg>
                              </span>
                            ) : (
                              <span className="not-selected-box" />
                            )}
                          </div>
                          <div className="et-level3">
                            <Collapse
                              in={this.state.holiday}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div
                                className="depedent-select-list"
                                onClick={() =>
                                  this.handleChange(
                                    "isinterviningholiday",
                                    !this.state.isinterviningholiday,
                                  )
                                }
                                aria-expanded={this.state.isinterviningholiday}
                              >
                                <span>
                                  <FormattedMessage
                                    id="LbInBetweenDeduct1"
                                    defaultMessage="In between leave (intervening/sandwiched)"
                                  />
                                </span>
                                {this.state.isinterviningholiday ? (
                                  <span className="floatright selected-box">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M0 0h24v24H0z" fill="none" />
                                      <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                    </svg>
                                  </span>
                                ) : (
                                  <span className="not-selected-box" />
                                )}
                              </div>
                              <div className="et-level4">
                                {/* <Collapse in={this.state.isinterviningholiday} timeout={2} unmountOnExit className="padding30 overflow-initial">

                                                        <div className="depedent-select-list" aria-expanded={this.state.holidayinterviningcount == null ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbAll" defaultMessage="All" />
                                                            </span>
                                                            <span onClick={() => this.CommonNumberChange("holidayinterviningcount", null)}>
                                                                {this.state.holidayinterviningcount == null ?
                                                                    <span className="floatright">
                                                                        <img src={CheckImg} height="20" />
                                                                    </span>
                                                                    : <span className="not-selected "></span>}</span>
                                                        </div>
                                                        <div className="depedent-select-list" aria-expanded={this.state.holidayinterviningcount != null ? true : false}>
                                                            <div className="inlindClass" style={{ width: "95%" }}>

                                                                <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="holidayinterviningcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "holidayinterviningcount", 7)}
                                                                    value={this.state.holidayinterviningcount}
                                                                    defaultvalue={this.state.holidayinterviningcount}
                                                                    disabled={this.state.holidayinterviningcount == null ? true : false}
                                                                />
                                                                <FormattedMessage id="LbDeductSandwich" defaultMessage="holidays which fall in between the leave duration, as leaves too" />

                                                            </div>
                                                            <div className="inlindClass">
                                                                <span onClick={() => this.CommonNumberChange("holidayinterviningcount", 1)}>
                                                                    {this.state.holidayinterviningcount != null ? <span className="floatright "> <img src={CheckImg} height="20" /> </span> : <span className="not-selected "></span>}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <p class="depedent-select-list margin-top-20 padding-bottom-0">
                                                            <FormattedMessage id="LbTwoDiffLeaves" defaultMessage="Apply these rules if employee has used 2 different types of leaves in the above situations?" />
                                                        </p>
                                                        <div className="depedent-select-list" onClick={() => this.handleChange("isholidayinterviningclubbed", true)} aria-expanded={this.state.isholidayinterviningclubbed == true ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbYes" defaultMessage="Yes" />
                                                            </span>
                                                            {this.state.isholidayinterviningclubbed == true ?
                                                                <span className="floatright ">
                                                                    <img src={CheckImg} height="20" />
                                                                </span>
                                                                : <span className="not-selected "></span>}
                                                        </div>
                                                        <div className="depedent-select-list" onClick={() => this.handleChange("isholidayinterviningclubbed", false)} aria-expanded={this.state.isholidayinterviningclubbed == false ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbNo" defaultMessage="No" />
                                                            </span>
                                                            {this.state.isholidayinterviningclubbed == false ?
                                                                <span className="floatright ">
                                                                    <img src={CheckImg} height="20" />
                                                                </span>
                                                                : <span className="not-selected "></span>}
                                                        </div>
                                                    </Collapse> */}
                              </div>
                              <div>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange(
                                      "isprefixholiday",
                                      !this.state.isprefixholiday,
                                    )
                                  }
                                  aria-expanded={this.state.isprefixholiday}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="LbBeforeLeave1"
                                      defaultMessage="Before leave (prefix)"
                                    />
                                  </span>
                                  {this.state.isprefixholiday ? (
                                    <span className="floatright selected-box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="not-selected-box" />
                                  )}
                                </div>
                                {/* <div className="et-level4">
                                                        <Collapse in={this.state.isprefixholiday} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                            <div className="depedent-select-list" aria-expanded={this.state.holidayprefixcount == null ? true : false}>
                                                                <span>
                                                                    <FormattedMessage id="LbAll" defaultMessage="All" />
                                                                </span>
                                                                <span onClick={() => this.CommonNumberChange("holidayprefixcount", null)}>
                                                                    {this.state.holidayprefixcount == null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}</span>
                                                            </div>
                                                            <div className="depedent-select-list" aria-expanded={this.state.holidayprefixcount != null ? true : false}>
                                                            <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="holidayprefixcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "holidayprefixcount", 7)}
                                                                    value={this.state.holidayprefixcount}
                                                                    defaultvalue={this.state.holidayprefixcount}
                                                                    disabled={this.state.holidayprefixcount == null ? true : false}
                                                                />

                                                                <FormattedMessage id="LbAdjoiningHolidays" defaultMessage="adjoining holidays as leaves too" />
                                                                <span onClick={() => this.CommonNumberChange("holidayprefixcount", 1)}>
                                                                    {this.state.holidayprefixcount != null ? <span className="floatright padding-top-15"> <img src={CheckImg} height="20" /> </span> : <span className="not-selected margin-top-15"></span>}
                                                                </span>
                                                            </div>
                                                        </Collapse>
                                                    </div> */}
                              </div>
                              <div>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange(
                                      "issuffixholiday",
                                      !this.state.issuffixholiday,
                                    )
                                  }
                                  aria-expanded={this.state.issuffixholiday}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="__LbBeforeLeave"
                                      defaultMessage="After leave (suffix)"
                                    />
                                  </span>
                                  {this.state.issuffixholiday ? (
                                    <span className="floatright selected-box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="not-selected-box" />
                                  )}
                                </div>
                                {/* <div className="et-level4">
                                                        <Collapse in={this.state.issuffixholiday} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                            <div className="depedent-select-list" aria-expanded={this.state.holidaysuffixcount == null ? true : false}>
                                                                <span>
                                                                    <FormattedMessage id="LbAll" defaultMessage="All" />
                                                                </span>
                                                                <span onClick={() => this.CommonNumberChange("holidaysuffixcount", null)}>
                                                                    {this.state.holidaysuffixcount == null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}</span>
                                                            </div>
                                                            <div className="depedent-select-list" aria-expanded={this.state.holidaysuffixcount != null ? true : false}>
                                                                <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="holidaysuffixcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "holidaysuffixcount", 7)}
                                                                    value={this.state.holidaysuffixcount}
                                                                    defaultvalue={this.state.holidayprefixcount}
                                                                    disabled={this.state.holidaysuffixcount == null ? true : false}
                                                                />

                                                                <FormattedMessage id="LbAdjoiningHolidays" defaultMessage="adjoining holidays as leaves too" />
                                                                <span onClick={() => this.CommonNumberChange("holidaysuffixcount", 1)}>
                                                                    {this.state.holidaysuffixcount != null ?
                                                                        <span className="floatright padding-top-15 ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected margin-top-15"></span>}
                                                                </span>
                                                            </div>
                                                        </Collapse>
                                                    </div> */}
                              </div>
                            </Collapse>
                          </div>
                        </div>
                        <div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange(
                                "optholiday",
                                !this.state.optholiday,
                              )
                            }
                            aria-expanded={this.state.optholiday}
                          >
                            <span>
                              <FormattedMessage
                                id="LbOptHolidayFalls"
                                defaultMessage="Deduct if optional holidays occurs"
                              />
                            </span>
                            {this.state.optholiday ? (
                              <span className="floatright selected-box">
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                  <path d="M0 0h24v24H0z" fill="none" />
                                  <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                </svg>
                              </span>
                            ) : (
                              <span className="not-selected-box" />
                            )}
                          </div>
                          <div className="et-level3">
                            <Collapse
                              in={this.state.optholiday}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div
                                className="depedent-select-list"
                                onClick={() =>
                                  this.handleChange(
                                    "isinterviningoptholiday",
                                    !this.state.isinterviningoptholiday,
                                  )
                                }
                                aria-expanded={
                                  this.state.isinterviningoptholiday
                                }
                              >
                                <span>
                                  <FormattedMessage
                                    id="LbInBetweenDeduct1"
                                    defaultMessage="In between leave (intervening/sandwiched)"
                                  />
                                </span>
                                {this.state.isinterviningoptholiday ? (
                                  <span className="floatright selected-box">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M0 0h24v24H0z" fill="none" />
                                      <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                    </svg>
                                  </span>
                                ) : (
                                  <span className="not-selected-box" />
                                )}
                              </div>
                              {/* <div className="et-level4">
                                                    <Collapse in={this.state.isinterviningoptholiday} timeout={2} unmountOnExit className="padding30 overflow-initial">

                                                        <div className="depedent-select-list" aria-expanded={this.state.optholidayinterviningcount == null ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbAll" defaultMessage="All" />
                                                            </span>
                                                            <span onClick={() => this.CommonNumberChange("optholidayinterviningcount", null)}>
                                                                {this.state.optholidayinterviningcount == null ?
                                                                    <span className="floatright">
                                                                        <img src={CheckImg} height="20" />
                                                                    </span>
                                                                    : <span className="not-selected "></span>}</span>
                                                        </div>
                                                        <div className="depedent-select-list" aria-expanded={this.state.optholidayinterviningcount != null ? true : false}>
                                                            <div className="inlindClass" style={{ width: "95%" }}>

                                                                <FormattedMessage id="#" defaultMessage="upto" />
                                                                <span className="floatleft">

                                                                    <InputValues
                                                                        min="1"
                                                                        max="7"
                                                                        field="optholidayinterviningcount"
                                                                        onChange={this.CommonNumberChange.bind(this, "optholidayinterviningcount", 7)}
                                                                        value={this.state.optholidayinterviningcount}
                                                                        defaultvalue={this.state.optholidayinterviningcount}
                                                                        disabled={this.state.optholidayinterviningcount == null ? true : false}
                                                                    />
                                                                </span>

                                                                <FormattedMessage id="LbDeductSandwichOpt" defaultMessage="optional holidays which fall in between the leave duration, as leaves too" />

                                                            </div>
                                                            <div className="inlindClass">
                                                                <span onClick={() => this.CommonNumberChange("optholidayinterviningcount", 1)}>
                                                                    {this.state.optholidayinterviningcount != null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <p className="depedent-select-list-head margin-top-20">
                                                            <FormattedMessage id="LbTwoDiffLeaves" defaultMessage="Apply these rules if employee has used 2 different types of leaves in the above situations?" />
                                                        </p>
                                                        <div className="depedent-select-list" onClick={() => this.handleChange("isoptholidayinterviningclubbed", true)} aria-expanded={this.state.isoptholidayinterviningclubbed == true ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbYes" defaultMessage="Yes" />
                                                            </span>
                                                            {this.state.isoptholidayinterviningclubbed == true ?
                                                                <span className="floatright ">
                                                                    <img src={CheckImg} height="20" />
                                                                </span>
                                                                : <span className="not-selected "></span>}
                                                        </div>
                                                        <div className="depedent-select-list" onClick={() => this.handleChange("isoptholidayinterviningclubbed", false)} aria-expanded={this.state.isoptholidayinterviningclubbed == false ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbNo" defaultMessage="No" />
                                                            </span>
                                                            {this.state.isoptholidayinterviningclubbed == false ?
                                                                <span className="floatright ">
                                                                    <img src={CheckImg} height="20" />
                                                                </span>
                                                                : <span className="not-selected "></span>}
                                                        </div>
                                                    </Collapse>
                                                </div> */}
                              <div>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange(
                                      "isprefixoptholiday",
                                      !this.state.isprefixoptholiday,
                                    )
                                  }
                                  aria-expanded={this.state.isprefixoptholiday}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="LbBeforeLeave1"
                                      defaultMessage="Before leave (prefix)"
                                    />
                                  </span>
                                  {this.state.isprefixoptholiday ? (
                                    <span className="floatright selected-box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="not-selected-box" />
                                  )}
                                </div>
                                {/* <div className="et-level4">
                                                        <Collapse in={this.state.isprefixoptholiday} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                            <div className="depedent-select-list" aria-expanded={this.state.optholidayprefixcount == null ? true : false}>
                                                                <span>
                                                                    <FormattedMessage id="LbAll" defaultMessage="All" />
                                                                </span>
                                                                <span onClick={() => this.CommonNumberChange("optholidayprefixcount", null)}>
                                                                    {this.state.optholidayprefixcount == null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}</span>
                                                            </div>
                                                            <div className="depedent-select-list" aria-expanded={this.state.optholidayprefixcount != null ? true : false}>
                                                            <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="optholidayprefixcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "optholidayprefixcount", 7)}
                                                                    value={this.state.optholidayprefixcount}
                                                                    defaultvalue={this.state.optholidayprefixcount}
                                                                    disabled={this.state.optholidayprefixcount == null ? true : false}
                                                                />

                                                                <FormattedMessage id="LbAdjoiningHolidaysOpt" defaultMessage="adjoining optional holidays as leaves too" />
                                                                <span onClick={() => this.CommonNumberChange("optholidayprefixcount", 1)}>
                                                                    {this.state.optholidayprefixcount != null ?
                                                                        <span className="floatright padding-top-15">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected margin-top-15"></span>}
                                                                </span>
                                                            </div>
                                                        </Collapse>
                                                    </div> */}
                              </div>
                              <div>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange(
                                      "issuffixoptholiday",
                                      !this.state.issuffixoptholiday,
                                    )
                                  }
                                  aria-expanded={this.state.issuffixoptholiday}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="__LbBeforeLeave"
                                      defaultMessage="After leave (suffix)"
                                    />
                                  </span>
                                  {this.state.issuffixoptholiday ? (
                                    <span className="floatright selected-box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="not-selected-box" />
                                  )}
                                </div>
                                {/* <div className="et-level4">
                                                        <Collapse in={this.state.issuffixoptholiday} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                            <div className="depedent-select-list" aria-expanded={this.state.optholidaysuffixcount == null ? true : false}>
                                                                <span>
                                                                    <FormattedMessage id="LbAll" defaultMessage="All" />
                                                                </span>
                                                                <span onClick={() => this.CommonNumberChange("optholidaysuffixcount", null)}>
                                                                    {this.state.optholidaysuffixcount == null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}</span>
                                                            </div>
                                                            <div className="depedent-select-list" aria-expanded={this.state.optholidaysuffixcount != null ? true : false}>


                                                                <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="optholidaysuffixcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "optholidaysuffixcount", 7)}
                                                                    value={this.state.optholidaysuffixcount}
                                                                    defaultvalue={this.state.optholidaysuffixcount}
                                                                    disabled={this.state.optholidaysuffixcount == null ? true : false}
                                                                />

                                                                <FormattedMessage id="LbAdjoiningHolidaysOpt" defaultMessage="adjoining optional holidays as leaves too" />
                                                                <span onClick={() => this.CommonNumberChange("optholidaysuffixcount", 1)}>
                                                                    {this.state.optholidaysuffixcount != null ?
                                                                        <span className="floatright padding-top-15">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected margin-top-15"></span>}
                                                                </span>
                                                            </div>
                                                        </Collapse>
                                                    </div> */}
                              </div>
                            </Collapse>
                          </div>
                        </div>
                        <div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange(
                                "weeklyoff",
                                !this.state.weeklyoff,
                              )
                            }
                            aria-expanded={this.state.weeklyoff}
                          >
                            <span>
                              <FormattedMessage
                                id="__LbWeekOffFalls"
                                defaultMessage="Deduct if weekly-offs occurs"
                              />
                            </span>
                            {this.state.weeklyoff ? (
                              <span className="floatright selected-box">
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                  <path d="M0 0h24v24H0z" fill="none" />
                                  <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                </svg>
                              </span>
                            ) : (
                              <span className="not-selected-box" />
                            )}
                          </div>
                          <div className="et-level3">
                            <Collapse
                              in={this.state.weeklyoff}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div
                                className="depedent-select-list"
                                onClick={() =>
                                  this.handleChange(
                                    "isinterviningweeklyoff",
                                    !this.state.isinterviningweeklyoff,
                                  )
                                }
                                aria-expanded={
                                  this.state.isinterviningweeklyoff
                                }
                              >
                                <span>
                                  <FormattedMessage
                                    id="LbInBetweenDeduct1"
                                    defaultMessage="In between leave (intervening/sandwiched)"
                                  />
                                </span>
                                {this.state.isinterviningweeklyoff ? (
                                  <span className="floatright selected-box">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M0 0h24v24H0z" fill="none" />
                                      <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                    </svg>
                                  </span>
                                ) : (
                                  <span className="not-selected-box" />
                                )}
                              </div>
                              {/* <div className="et-level4">
                                                    <Collapse in={this.state.isinterviningweeklyoff} timeout={2} unmountOnExit className="padding30 overflow-initial">

                                                        <div className="depedent-select-list" aria-expanded={this.state.weeklyoffinterviningcount == null ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbAll" defaultMessage="All" />
                                                            </span>
                                                            <span onClick={() => this.CommonNumberChange("weeklyoffinterviningcount", null)}>
                                                                {this.state.weeklyoffinterviningcount == null ?
                                                                    <span className="floatright">
                                                                        <img src={CheckImg} height="20" />
                                                                    </span>
                                                                    : <span className="not-selected "></span>}</span>
                                                        </div>
                                                        <div className="depedent-select-list" aria-expanded={this.state.weeklyoffinterviningcount != null ? true : false}>
                                                            <div className="inlindClass" style={{ width: "95%" }}>

                                                                <FormattedMessage id="LbDeductSandwichWeekly" defaultMessage="weekly-offs which fall in between the leave duration, as leaves too" />

                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="weeklyoffinterviningcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "weeklyoffinterviningcount", 7)}
                                                                    value={this.state.weeklyoffinterviningcount}
                                                                    defaultvalue={this.state.weeklyoffinterviningcount}
                                                                    disabled={this.state.weeklyoffinterviningcount == null ? true : false}
                                                                />

                                                            </div>
                                                            <div className="inlindClass" >
                                                                <span onClick={() => this.CommonNumberChange("weeklyoffinterviningcount", 1)}>
                                                                    {this.state.weeklyoffinterviningcount != null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <p class="depedent-select-list-head margin-top-20">
                                                            <FormattedMessage id="LbTwoDiffLeaves" defaultMessage="Apply these rules if employee has used 2 different types of leaves in the above situations?" />
                                                        </p>
                                                        <div className="depedent-select-list" onClick={() => this.handleChange("isweeklyoffinterviningclubbed", true)} aria-expanded={this.state.isweeklyoffinterviningclubbed == true ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbYes" defaultMessage="Yes" />
                                                            </span>
                                                            {this.state.isweeklyoffinterviningclubbed == true ?
                                                                <span className="floatright ">
                                                                    <img src={CheckImg} height="20" />
                                                                </span>
                                                                : <span className="not-selected "></span>}
                                                        </div>
                                                        <div className="depedent-select-list" onClick={() => this.handleChange("isweeklyoffinterviningclubbed", false)} aria-expanded={this.state.isweeklyoffinterviningclubbed == false ? true : false}>
                                                            <span>
                                                                <FormattedMessage id="LbNo" defaultMessage="No" />
                                                            </span>
                                                            {this.state.isweeklyoffinterviningclubbed == false ?
                                                                <span className="floatright ">
                                                                    <img src={CheckImg} height="20" />
                                                                </span>
                                                                : <span className="not-selected "></span>}
                                                        </div>
                                                    </Collapse>
                                                </div> */}
                              <div>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange(
                                      "isprefixweeklyoff",
                                      !this.state.isprefixweeklyoff,
                                    )
                                  }
                                  aria-expanded={this.state.isprefixweeklyoff}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="LbBeforeLeave1"
                                      defaultMessage="Before leave (prefix)"
                                    />
                                  </span>
                                  {this.state.isprefixweeklyoff ? (
                                    <span className="floatright selected-box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="not-selected-box" />
                                  )}
                                </div>
                                {/* <div className="et-level4">
                                                        <Collapse in={this.state.isprefixweeklyoff} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                            <div className="depedent-select-list" aria-expanded={this.state.weeklyoffprefixcount == null ? true : false}>
                                                                <span>
                                                                    <FormattedMessage id="LbAll" defaultMessage="All" />
                                                                </span>
                                                                <span onClick={() => this.CommonNumberChange("weeklyoffprefixcount", null)}>
                                                                    {this.state.weeklyoffprefixcount == null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}</span>
                                                            </div>
                                                            <div className="depedent-select-list" aria-expanded={this.state.weeklyoffprefixcount != null ? true : false}>
                                                            <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="weeklyoffprefixcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "weeklyoffprefixcount", 7)}
                                                                    value={this.state.weeklyoffprefixcount}
                                                                    defaultvalue={this.state.weeklyoffprefixcount}
                                                                    disabled={this.state.weeklyoffprefixcount == null ? true : false}
                                                                />

                                                                <FormattedMessage id="LbAdjoiningHolidaysWeekly" defaultMessage="adjoining weekly-offs as leaves too" />
                                                                <span onClick={() => this.CommonNumberChange("weeklyoffprefixcount", 1)}>
                                                                    {this.state.weeklyoffprefixcount != null ?
                                                                        <span className="floatright padding-top-15">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected margin-top-15"></span>}
                                                                </span>
                                                            </div>
                                                        </Collapse>
                                                    </div> */}
                              </div>
                              <div>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange(
                                      "issuffixweeklyoff",
                                      !this.state.issuffixweeklyoff,
                                    )
                                  }
                                  aria-expanded={this.state.issuffixweeklyoff}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="__LbBeforeLeave"
                                      defaultMessage="After leave (suffix)"
                                    />
                                  </span>
                                  {this.state.issuffixweeklyoff ? (
                                    <span className="floatright selected-box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="not-selected-box" />
                                  )}
                                </div>
                                {/* <div className="et-level4">
                                                        <Collapse in={this.state.issuffixweeklyoff} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                            <div className="depedent-select-list" aria-expanded={this.state.weeklyoffsuffixcount == null ? true : false}>
                                                                <span>
                                                                    <FormattedMessage id="LbAll" defaultMessage="All" />
                                                                </span>
                                                                <span onClick={() => this.CommonNumberChange("weeklyoffsuffixcount", null)}>
                                                                    {this.state.weeklyoffsuffixcount == null ?
                                                                        <span className="floatright ">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected "></span>}</span>
                                                            </div>
                                                            <div className="depedent-select-list" aria-expanded={this.state.weeklyoffsuffixcount != null ? true : false}>

                                                                <FormattedMessage id="#" defaultMessage="upto" />
                                                                <InputValues
                                                                    min="1"
                                                                    max="7"
                                                                    field="weeklyoffsuffixcount"
                                                                    onChange={this.CommonNumberChange.bind(this, "weeklyoffsuffixcount", 7)}
                                                                    value={this.state.weeklyoffsuffixcount}
                                                                    defaultvalue={this.state.weeklyoffsuffixcount}
                                                                    disabled={this.state.weeklyoffsuffixcount == null ? true : false}
                                                                />

                                                                <FormattedMessage id="LbAdjoiningHolidaysWeekly" defaultMessage="adjoining weekly-offs as leaves too" />
                                                                <span onClick={() => this.CommonNumberChange("weeklyoffsuffixcount", 1)}>
                                                                    {this.state.weeklyoffsuffixcount != null ?
                                                                        <span className="floatright padding-top-15">
                                                                            <img src={CheckImg} height="20" />
                                                                        </span>
                                                                        : <span className="not-selected margin-top-15"></span>}
                                                                </span>
                                                            </div>
                                                        </Collapse>
                                                    </div> */}
                              </div>
                            </Collapse>
                          </div>
                        </div>
                      </Collapse>
                    </div>

                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isintervinigallowed", false)
                      }
                      aria-expanded={this.state.isintervinigallowed == false}
                    >
                      <span>No, deduct leaves only for applied dates</span>
                      {this.state.isintervinigallowed == false ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </IntlProvider>
    );
  }
}
SandwichLeave.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(SandwichLeave)));
